/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorInviteLogDto } from '../../models/vendor-invite-log-dto';
import { VendorInviteWorkspaceUserDto } from '../../models/vendor-invite-workspace-user-dto';

export interface VendorWorkspaceInviteLogControlllerInviteUser$Params {

/**
 * 입점사 ID
 */
  id: string;
      body: VendorInviteWorkspaceUserDto
}

export function vendorWorkspaceInviteLogControlllerInviteUser(http: HttpClient, rootUrl: string, params: VendorWorkspaceInviteLogControlllerInviteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorInviteLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceInviteLogControlllerInviteUser.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorInviteLogDto>;
    })
  );
}

vendorWorkspaceInviteLogControlllerInviteUser.PATH = '/api/vendorWorkspaceInviteLogs/{id}/invite';
